import styled, { css, DefaultTheme } from 'styled-components';

type IndicatorProps = {
  color: string;
};

type TextProps = {
  color: keyof DefaultTheme['colors'];
};

export const Wrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const Indicator = styled.div<IndicatorProps>`
  ${({ color }) => css`
    background-color: ${color};
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-top: 8px;
  `}
`;

export const Text = styled.p<TextProps>`
  ${({ theme, color }) => css`
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-weight: 500;
    color: ${theme.colors[color]};
  `}
`;

export const LegendWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TooltipContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
